import actions from 'src/modules/data/list/dataListActions';
import DataService from '../dataService';

const INITIAL_PAGE_SIZE = 10;

const initialData = {
  rows: [] as Array<any>,
  count: 0,
  missingFolios: [],
  loading: false,
  filter: {},
  rawFilter: {},
  pagination: {
    current: 1,
    pageSize: INITIAL_PAGE_SIZE,
  },
  sorter: {},
  selectedKeys: [] as Array<any>,
  entity: null,
  entityStructure: {},
  entityCustomFields: [],
};

export default (state = initialData, {type, payload}) => {
  if (type === actions.RESETED || type === actions.SELECTED_ENTITY) {
    let resetState = {
      ...initialData,
      filter: payload?.defaultFilter || {},
      rawFilter: payload?.defaultFilter || {},
      entity: state.entity,
      entityStructure: state.entityStructure,
      entityCustomFields: state.entityCustomFields,
    };
    if (type === actions.SELECTED_ENTITY) {
      resetState = {
        ...resetState,
        entity: payload?.entity || null,
        entityStructure: {},
        entityCustomFields: [],
      };
    }
    return resetState;
  }

  if (type === actions.TOGGLE_ONE_SELECTED) {
    let selectedKeys = state.selectedKeys;

    const exists = selectedKeys.some((data) => {
      return data.dataId === payload.dataId && data.dateStart === payload.dateStart;
    });

    if (exists) {
      selectedKeys = selectedKeys.filter((data) => {
        return !(data.dataId === payload.dataId && data.dateStart === payload.dateStart);
      });
    } else {
      selectedKeys = [payload, ...selectedKeys];
    }

    return {
      ...state,
      selectedKeys,
    };
  }

  if (type === actions.TOGGLE_ALL_SELECTED) {
    const isAllSelected = (state.rows || []).length === (state.selectedKeys || []).length;

    return {
      ...state,
      selectedKeys: isAllSelected ? [] : state.rows.map((row) => ({dataId: row.dataId, dateStart: row.dateStart || null})),
    };
  }

  if (type === actions.CLEAR_ALL_SELECTED) {
    return {
      ...state,
      selectedKeys: [],
    };
  }

  if (type === actions.PAGINATION_CHANGED) {
    return {
      ...state,
      pagination: payload || {
        current: 1,
        pageSize: INITIAL_PAGE_SIZE,
      },
    };
  }

  if (type === actions.SORTER_CHANGED) {
    return {
      ...state,
      sorter: payload || {},
    };
  }

  if (type === actions.FETCH_STARTED) {
    return {
      ...state,
      loading: true,
      selectedKeys: [],
      filter: payload ? payload.filter : {},
      rawFilter: payload ? payload.rawFilter : {},
      pagination:
        payload && payload.keepPagination
          ? state.pagination
          : {
              current: 1,
              pageSize: INITIAL_PAGE_SIZE,
            },
      //entityStructure: {},
      //entityCustomFields: [],
    };
  }

  if (type === actions.FETCH_SUCCESS) {
    const {entityStructure, entityCustomFields} = DataService.makeStructure(payload.rows || [], payload.structure || {});
    //console.log('%c⧭ entityStructure', 'color: #ffcc00', entityStructure);
    //console.log('%c⧭ entityCustomFields', 'color: #ffcc00', entityCustomFields);
    return {
      ...state,
      loading: false,
      rows: payload.rows,
      count: payload.count,
      missingFolios: payload.missingFolios || [],
      entityStructure: entityStructure,
      entityCustomFields: entityCustomFields,
    };
  }

  if (type === actions.SET_STRUCTURE) {
    const {entityStructure, entityCustomFields} = DataService.makeStructure(state.rows || [], payload.structure || {});
    console.log('%c⧭ actions.SET_STRUCTURE', 'color: #e50000', entityStructure);
    return {
      ...state,
      entityStructure: entityStructure,
      entityCustomFields: entityCustomFields,
    };
  }

  if (type === actions.FETCH_ERROR) {
    return {
      ...state,
      loading: false,
      rows: [],
      count: 0,
      missingFolios: [],
    };
  }

  if (type === actions.EXPORT_STARTED) {
    return {
      ...state,
      exportLoading: true,
    };
  }

  if (type === actions.EXPORT_SUCCESS) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  if (type === actions.EXPORT_ERROR) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  return state;
};
